import { Customer } from '../models/customer';
import { Employment, EmploymentStatusEnum } from '../models/employment';

export function checkCanCancelEmployment(
  employment: Employment,
  loggedInCustomer: Customer,
) {
  return (
    employment &&
    employment.status != EmploymentStatusEnum.CANCELED &&
    loggedInCustomer &&
    employment.customer &&
    (loggedInCustomer._id == employment.customer.id ||
      employment.ownerCustomerIds?.includes(loggedInCustomer._id))
  );
}
